import React, {memo} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import styles from './WeatherInformer.css';

export const WeatherInformer = memo(() => {
	const t = useLocalizer();

	const href = `/informers?lang=${t.language}`;

	return (
		<div className={styles.root}>
			<a className={styles.title} href={href}>
				{t('informerTitle')}
			</a>
			<p className={styles.info}>{t('informerInfo')}</p>
			<a className={styles.link} href={href}>
				{t('informerLink')}
			</a>
		</div>
	);
});

WeatherInformer.displayName = 'WeatherInformer';
